<p-dialog header="Header"
          [(visible)]="visible"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [focusOnShow]="false"
          styleClass="h-screen! max-h-screen! w-screen! rounded-none!">
  <ng-template #header>
    <div class="flex-flex-col w-full gap-1">
      <label class="text-left font-bold">{{ 'titles.accSignals' | translate }}</label>
      <p-divider />
    </div>
  </ng-template>

  <p-splitter [panelSizes]="[15, 85]" class="h-full">
    <p-splitter-panel [minSize]="10" class="flex h-full flex-col gap-3 overflow-hidden p-3">
      <span>{{ 'parameters.metrics' | translate }}</span>
      <p-floatlabel variant="on">
        <p-datepicker [(ngModel)]="startDate" inputId="startDate" showIcon iconDisplay="input" [showTime]="true" />
        <label for="startDate">{{ 'from' | translate}}</label>
      </p-floatlabel>
      <p-floatlabel variant="on">
        <p-datepicker [(ngModel)]="endDate" inputId="endDate" showIcon iconDisplay="input" [showTime]="true" />
        <label for="endDate">{{ 'to' | translate}}</label>
      </p-floatlabel>
      <p-button [label]="'primeng.apply' | translate"
                (click)="onApply()" />

      <p-divider />

      <span>{{ 'titles.listEvents' | translate }}</span>
      <p-listbox [options]="events" optionLabel="measure"
                 scrollHeight="flex"
                 [style]="{ 'flex': '1 1 0%', 'min-height': '150px' }"
                 styleClass="flex w-full flex-col items-stretch">
        <ng-template #item let-event>
          <div class="flex w-full flex-row items-center gap-1 pr-4">
            @if(event.missing) {
            <i class="pi pi-times justify-self-center"></i>
            } @else if(event.higher) {
            <i class="pi pi-arrow-up justify-self-center"></i>
            } @else {
            <i class="pi pi-arrow-down justify-self-center"></i>
            }
            <div class="flex flex-col gap-1">
              <span class="truncate">{{ 'parameters.' + event.measure | translate }}</span>
              <span class="text-xs">{{ event.timeStamp | date:'medium' }}</span>
            </div>
          </div>
        </ng-template>
      </p-listbox>
    </p-splitter-panel>
    <p-splitter-panel>
      <!-- Contenitore principale: occupa tutto lo spazio e si imposta come colonna flex -->
      <div class="flex h-full w-full flex-col p-3">
        <!-- Area scrollabile: min-h-0 forza Flexbox a contenere gli elementi invece di espandersi -->
        <div class="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto p-4">
          <app-signal [titolo]="'titles.accSignals' | translate" [udm]="'G'"
                      (onZoomChanged)="onZoomChanged($event)" (onZoomCommand)="onZoomCommand($event)"
                      [zoomLevel]="zoomLevel.asObservable()" [zoomCommand]="zoomCommand.asObservable()"
                      [xMax]="xMax" [xMin]="xMin"
                      [segnale]="segnaleAcc" [loading]="loading"
                      [useLegend]="true" [labels]="legendLabels"
                      chartHeight="50vh"/>

        </div>
      </div>
    </p-splitter-panel>
  </p-splitter>

  <ng-template #footer>
    <p-button class="me-32"
              [label]="'primeng.aria.close' | translate"
              (click)="onClose()" />
  </ng-template>
</p-dialog>
